<template>
  <section>
    <div id="modal-center" class="uk-modal-container" uk-modal esc-close="false" bg-close="false">
      <div class="uk-modal-dialog">
        <button class="uk-modal-close-default" type="button" uk-close @click="hideModal" />
        <div class="uk-modal-header uk-text-center">
          <h2 class="uk-modal-title">Lampiran</h2>
        </div>
        <div class="uk-modal-body" style="position: relative;">
          <iframe
            :src="`https://view.officeapps.live.com/op/embed.aspx?src=${url}&wdEmbedCode=0&wdAccPdf=1`"
            height="700px"
            width="100%"
            frameborder="0"
          />
          <div class="copyright-hidding" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            required: true,
        },
    },
    mounted() {
        window.UIkit.modal('#modal-center').show();
    },
    methods: {
        hideModal() {
            window.UIkit.modal('#modal-center').$destroy(true);
            this.$emit("hideModal");
        },
        download(img) {
            window.location = img;
        },
    }
};
</script>

<style scoped>
.copyright-hidding {
  position: absolute;
  width: 100%;
  height: 22px;
  background: #fff;
  left: 0;
  bottom: 30px;
}
</style>
